import {atom} from 'recoil';

export default atom<{text: string; value: string}[]>({
  key: 'filterOptionsAtom',
  default: [],
});
